import { motion } from "framer-motion";
import { Check, Info } from "lucide-react";

import { Container } from "@/components/ui/Container";
import { Section } from "@/components/ui/Section";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { CAPABILITIES } from "@/data/content";
import { staggerContainer, staggerItem, viewportOnce } from "@/lib/motion";

interface CapabilitiesProps {
  withHeading?: boolean;
  muted?: boolean;
}

export function Capabilities({ withHeading = true, muted = true }: CapabilitiesProps) {
  return (
    <Section muted={muted} data-testid="capabilities-section">
      <Container>
        {withHeading && (
          <SectionHeading
            eyebrow="Therapeutic Areas & Site Capabilities"
            title={CAPABILITIES.heading}
          />
        )}
        <div
          className={`mx-auto max-w-3xl space-y-4 text-center text-base leading-relaxed text-muted-foreground ${
            withHeading ? "mt-6" : ""
          }`}
        >
          {CAPABILITIES.intro.map((p) => (
            <p key={p.slice(0, 24)}>{p}</p>
          ))}
        </div>

        <p className="mt-10 text-center text-sm font-semibold uppercase tracking-wider text-accent">
          Potential therapeutic areas
        </p>
        <motion.ul
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mx-auto mt-6 flex max-w-4xl flex-wrap justify-center gap-3"
        >
          {CAPABILITIES.areas.map((area) => (
            <motion.li
              key={area}
              variants={staggerItem}
              className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm font-medium text-foreground shadow-sm"
            >
              <Check size={14} className="text-primary" strokeWidth={3} />
              {area}
            </motion.li>
          ))}
        </motion.ul>

        <div className="mx-auto mt-8 flex max-w-2xl items-start gap-2.5 rounded-xl border border-border bg-background p-4 text-sm text-muted-foreground">
          <Info size={16} className="mt-0.5 shrink-0 text-secondary" />
          <span>{CAPABILITIES.note}</span>
        </div>
      </Container>
    </Section>
  );
}
